'use client';

import { AppInstallBannerDynamic } from '@/flat-pages/installation-guide/ui/app-install-banner/dynamic';
import { useShouldShowAppInstallBanner } from '@/flat-pages/installation-guide/ui/app-install-banner/hooks';
import { KycVerificationBannerDynamic } from '@/features/kyc-verification-banner/dynamic';
import { useShouldShowKycVerificationBanner } from '@/features/kyc-verification-banner/hooks';

const HeaderBanners = () => {
  const shouldShowKycVerificationBanner = useShouldShowKycVerificationBanner();
  const shouldShowAppInstallBanner = useShouldShowAppInstallBanner();

  return (
    <>
      {shouldShowKycVerificationBanner && <KycVerificationBannerDynamic />}
      {shouldShowAppInstallBanner && <AppInstallBannerDynamic />}
    </>
  );
};

export { HeaderBanners };
